<template>
  <div class="list-item">
    <div class="list-item-option" @click="handleTitleClick">
      <div class="title overh" :title="data.title" v-html="data.title"></div>
      <div class="time">{{ commonTime }}</div>
    </div>
    <AdsVue ref="ads" @handleClose="handleTitleClick"/>
  </div>
</template>

<script>
import AdsVue from "@components/sys/ads";
import {ToText, toTime} from "../assets/js/news.js";

export default {
  components: {
    AdsVue,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    detail: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: null,
    };
  },
  computed: {
    commonTime() {
      if (this.data.releaseTime) {
        return this.data.releaseTime.indexOf("-") > -1
          ? this.data.releaseTime.split(" ")[0]
          : toTime(this.data.releaseTime, false);
      }
    },
  },
  mounted() {
  },
  methods: {
    handleTitleClick(item) {
      this.$store.dispatch("analysis/updateHits", {
        visitlocation: "政策法规-详情",
      });
      this.loading = this.$loading({
        target: ".loading",
        text: "加载中...",
      });
      this.$ajax({
        type: "get",
        url: `${this.$store.state.api.baseWebUrl}` + this.detail,
        data: {
          id: this.data.id,
        },
        callback: (data) => {
          if (data.isView) {
            if (data.httpUrl.indexOf("<a") != -1) {
              let href = data.httpUrl.split('href="')[1].split('">')[0];
              this.judgePath(href);
            } else {
              this.judgePath(data.httpUrl);
            }
          } else {
            if (this.loading) {
              this.loading.close();
            }
            this.$refs.ads.showAdsDialog({
              relationId: item.id ? item.id : this.data.id,
              relationType: this.retype,
            });
          }
        },
        complete: function () {
          if (this.loading) {
            this.loading.close();
          }
        },
      });
    },

    //判断原网站是否可以打开
    judgePath(pathUrl) {
      this.$ajax({
        type: "get",
        url: `${this.$store.state.api.baseWebUrl}/yzkj/information/isViewPlatWeb`,
        data: {
          platWebUrl: pathUrl,
        },
        callback: (data) => {
          this.loading.close();
          if (data.isView) {
            //true代表当前路径可以打开
            window.open(pathUrl);
          } else {
            //路径打不开 需要访问本地页面
            this.$router.push({
              path:
                "/library/documentInfo?articleId=" +
                this.data.id +
                "&source=" +
                "library",
            });
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.list-item {
  line-height: 32px;

  &-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    cursor: pointer;

    .title {
      color: #242424;
      font-size: 14px;
      width: 220px;
    }

    .time {
      white-space: nowrap;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      line-height: 28px;
      margin-left: 20px;
    }
  }
}
</style>
